export default "__VITE_ASSET__MER$ykkK__"